import {JournalActivity, WatchedActivity} from "./types";
import {MuBinder} from "mu-widget/lib/MuBinder";
import {DateTime} from "mu-js-utils/lib/DateTime";
import {formatDuration} from "./filters";

export class JournalActivityUtils {
    public static formatActivity(journalActivity: JournalActivity): string
    {
        return journalActivity.activityName
            + (journalActivity.activityVariantName ? ' / ' + journalActivity.activityVariantName : '')
            + (journalActivity.customValues ? ' / ' + journalActivity.customValues.name : '');
    }

    public static formatValue(journalActivity: JournalActivity): string {
        return journalActivity.useTimeWatcher
            ? (journalActivity.value === null
                    ? MuBinder.filters.duration((new Date().getTime() - journalActivity.dtStart.getTime()) / 1000)
                    : MuBinder.filters.duration(journalActivity.value)
            )
            : (journalActivity.value === null
                    ? ''
                    : journalActivity.value + (journalActivity.activityOptions.unit ?? '')
            )
    }

    public static formatTime(journalActivity: JournalActivity): string {
        let res = DateTime.format(journalActivity.dtStart, 'H:i');
        if (journalActivity.useTimeWatcher && journalActivity.value)
            res += ' - ' + DateTime.format(DateTime.add(journalActivity.dtStart, journalActivity.value), 'H:i');

        return res;
    }

    static formatCurrentDuration(watchedActivity: WatchedActivity) {
        return formatDuration((new Date().getTime() - watchedActivity.dtStart.getTime()) / 1000);
    }
}